export enum Languages {
  ITALIAN = 'it',
  ENGLISH = 'en'
}
